<div class="form_container">
  <mat-accordion multi [class.hidden]="isLoadingForms || isLoadingPackets" #pane>
    <mat-expansion-panel (opened)="onOpenedPanel(expansionPanel.Forms)" (closed)="onClosedPanel(expansionPanel.Forms)"
      [expanded]="expandedPanel === expansionPanel.Forms" style="border-radius: 4px;">
      <mat-expansion-panel-header>
        <mat-panel-title>Forms</mat-panel-title>
      </mat-expansion-panel-header>

      <span *ngIf="!isLoadingForms && !assignments && assignments.length < 1">No forms found.</span>
      <div class="forms" *ngIf="!isLoadingForms || assignments.length > 0">
        <div *ngFor="let assignment of assignments">
          <mat-checkbox color="primary" [(ngModel)]="assignment.isChecked"
            (change)="onFormCheckChange(assignment.isChecked)" ngDefaultControl>{{ assignment.assignment.name
            }}</mat-checkbox>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="onOpenedPanel(expansionPanel.Packets)" (closed)="onClosedPanel(expansionPanel.Packets)"
      [expanded]="expandedPanel === expansionPanel.Packets" style="border-radius: 4px; margin: 0px;">
      <mat-expansion-panel-header>
        <mat-panel-title>Packets</mat-panel-title>
      </mat-expansion-panel-header>

      <span *ngIf="!isLoadingPackets && !packets && packets.length < 1">No packets found.</span>
      <div class="packets" *ngIf="!isLoadingPackets || packets.length > 0">
        <mat-radio-group [(ngModel)]="selectedPacketId">
          <div *ngFor="let packet of packets">
            <mat-radio-button color="primary" [value]="packet.id" ngDefaultControl>{{ packet.name }}</mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>